import React from 'react';
import tw from 'twin.macro';
//eslint-disable-next-line
import styled, { css } from 'styled-components/macro';
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from 'components/misc/Headings.js';
import { SectionDescription } from 'components/misc/Typography.js';

import defaultCardImage from 'images/shield-icon.svg';

import { ReactComponent as SvgDecoratorBlob3 } from 'images/svg-decorator-blob-3.svg';

import QualityCheckIconImage from 'images/quality-check-icon.svg';
import GraphIconImage from 'images/graph-icon.svg';
import MoneyIconImage from 'images/money-bag-icon.svg';
import FastIconImage from 'images/fast-icon.svg';
import TeamEmpowerIconImage from 'images/team-empower-icon.svg';
import IdeaIconImage from 'images/idea-icon.svg';

const Container = tw.div`relative`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-xl mx-auto py-20 md:py-24`}
`;
const Subheading = tw(SubheadingBase)`mb-4`;
const Heading = tw(SectionHeading)`w-full`;
const Description = tw(SectionDescription)`w-full text-center`;

const VerticalSpacer = tw.div`mt-10 w-full`;

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 max-w-sm`}
`;

const Card = styled.div`
  ${tw`flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left h-full mx-3 py-8`}
  .imageContainer {
    ${tw`border text-center rounded-full p-5 flex-shrink-0`}
    img {
      ${tw`w-8 h-8`}
    }
  }

  .textContainer {
    ${tw`sm:ml-4 mt-4 sm:mt-2`}
  }

  .title {
    ${tw`mt-4 tracking-wide font-bold text-2xl leading-none`}
  }

  .description {
    ${tw`mt-1 sm:mt-4 font-medium text-secondary-100 leading-loose text-sm`}
  }
`;

const DecoratorBlob = styled(SvgDecoratorBlob3)`
  ${tw`pointer-events-none absolute right-0 bottom-0 w-64 opacity-25 transform translate-x-32 translate-y-48 `}
`;

const HighlightedText = tw.span`text-primary-500`;

const Benefits = ({
  cards = null,
  heading = (
    <>
      Why <HighlightedText>Digitization</HighlightedText>?
    </>
  ),
  subheading = 'Advantages',
  description = null,
}) => {
  /*
   * This componets has an array of object denoting the cards defined below. Each object in the cards array can have the key (Change it according to your need, you can also add more objects to have more cards in this feature component) or you can directly pass this using the cards prop:
   *  1) imageSrc - the image shown at the top of the card
   *  2) title - the title of the card
   *  3) description - the description of the card
   *  If a key for a particular card is not provided, a default value is used
   */

  const defaultCards = [
    {
      imageSrc: GraphIconImage,
      title: 'Enhanced Data Analytics',
      description:
        'Enhanced data analytics drives informed decision-making and improved efficiency.',
    },
    {
      imageSrc: QualityCheckIconImage,
      title: 'Improved Quality Control',
      description:
        'Enhanced quality control optimizes software solutions, ensuring higher product quality and customer satisfaction.',
    },
    {
      imageSrc: IdeaIconImage,
      title: 'Innovation and Scalability',
      description:
        'Innovation and scalability drive software solutions, fostering adaptability and growth opportunities.',
    },
    {
      imageSrc: MoneyIconImage,
      title: 'Cost Reduction',
      description:
        'Optimized processes and resource utilization reduce costs and enhance software efficiency.',
    },
    {
      imageSrc: FastIconImage,
      title: 'Increased Efficiency',
      description:
        'Increased efficiency optimizes software performance, driving productivity and operational effectiveness.',
    },
    {
      imageSrc: TeamEmpowerIconImage,
      title: 'Workforce Empowerment',
      description:
        'Workforce empowerment maximizes software potential and organizational success.',
    },
  ];

  if (!cards) cards = defaultCards;

  return (
    <Container>
      <ThreeColumnContainer>
        {subheading && <Subheading>{subheading}</Subheading>}
        <Heading>{heading}</Heading>
        {description && <Description>{description}</Description>}
        <VerticalSpacer />
        {cards.map((card, i) => (
          <Column key={i}>
            <Card>
              <span className="imageContainer">
                <img src={card.imageSrc || defaultCardImage} alt="" />
              </span>
              <span className="textContainer">
                <span className="title">{card.title}</span>
                <p className="description">{card.description}</p>
              </span>
            </Card>
          </Column>
        ))}
      </ThreeColumnContainer>
      <DecoratorBlob />
    </Container>
  );
};

export default Benefits;
